export const style = {
  image: {
    width: 20,
  },
  noOptions: {
    display: 'flex',
    alignItems: 'center',
  },
  noOptionsText: {
    marginLeft: '4px',
  },
  noOptionsButton: {
    marginLeft: 'auto',
  },
};
